
import React, { useContext, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
//third party
import { useSelector, useDispatch } from 'react-redux'

import { myWebinars } from '../../../service/webinarsService'


const MyWebinars = () => {
    const user = useSelector((state) => state.user)
    const [getMyWebinars, setMyWeibars] = useState([])

    const handleGetMyWebinars = async () => {
        try {
            const { status, data } = await myWebinars(user.value.username);
            if (status === 200) {
                setMyWeibars(data.myWebinars)
            }
        } catch (ex) {
        }
    }

    const handleDisplayDeadTimeWebinar = (time) => {
        var date = new Date(time)
        var timestampDate = date.getTime()
        var add3month = timestampDate + 7776000000
        var toPersian = new Date(add3month).toLocaleDateString('fa-IR')
        return (toPersian)
    }

    useEffect(() => {
        handleGetMyWebinars()
    }, [user.value])

    return (
        <>
            <Helmet>
                <title> حساب کاربری | وبینار های من   </title>
            </Helmet>
            <div className='header'>
                <h3>وبینار های من</h3>
            </div>
            <div className='my-webinars'>
                {getMyWebinars.length == 0 ? (
                    <h3 className='no-content'>
                        <span>وبیناری  یافت نشد</span>
                        <i className='fa fa-exclamation-circle'></i>


                    </h3>
                ) : (
                    <>
                        {getMyWebinars.map(webinar => (
                            <Link key={webinar.id} to={`/webinars/${webinar.slug}`} className='webinar'>
                                <div className='info'>
                                    <span className='title'>{webinar.title}</span>
                                    {/* <span className='dead-line'>مهلت استفاده تا : {handleDisplayDeadTimeWebinar(webinar.createdTime)}</span> */}
                                </div>
                                <span>
                                    <i className='fa fa-angle-left'></i>
                                </span>
                            </Link>
                        ))}
                    </>
                )}

            </div>
        </>

    )
}


export default MyWebinars